import { useEffect } from "react";

/**
 * Attach IntersectionObserver once for any element with `.reveal` class.
 * Adds `.is-visible` when element enters viewport.
 */
export default function useReveal() {
  useEffect(() => {
    const elements = document.querySelectorAll(".reveal:not(.is-visible)");
    if (!elements.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );

    elements.forEach((el) => io.observe(el));
    return () => io.disconnect();
  });
}
